exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-inputtext {\r\n    height: 20px;\r\n    width: 100%;\r\n    padding: 0px 8px 0 8px;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n    display: block;\r\n    overflow: hidden;\r\n    border: 1px solid #959595;\r\n}\r\n.ui-inputtext:focus {\r\n    border: 1px solid #0091EA !important;\r\n    box-shadow: #0091EA !important;\r\n    box-sizing: border-box !important;\r\n}\r\n\r\n.ui-inputtext {\r\n    border-radius: 0px;\r\n}\r\n::ng-deep .time-comp-wrapper.ui-inputtext .ui-state-default {\r\n    border: transparent;\r\n}\r\n\r\n::ng-deep .time-comp-wrapper.ui-inputtext .ui-inputtext:focus {\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/time-mask/time-mask.component.css
// module id = ../../../../../src/app/shared/components/time-mask/time-mask.component.css
// module chunks = main